module.exports = __webpack_public_path__ + "static/media/precisionlifts.63cb5477.md";